import React, {useEffect, useRef} from 'react';
import ProductImageSlider from './ProductImageSlider.jsx';
import BackToShop from "./BackToShop.jsx";
import Details from "./Details.jsx";
import ProductAccordion from "./ProductAccordion.jsx";
import OtherCategories from "./OtherCategories.jsx";
import SoldOutCarousel from "./recommendations/sold-out/SoldOutCarousel.jsx";
import NitroTracker from "@dts/scripts/components/NitroTracker.jsx";
import PlattformAttributes
    from "@dts/scripts/components/PlattformAttributes.jsx";
import LastSeenStorage from "@wishlist/components/LastSeenStorage.jsx";
import SideSection from "@product/sections/SideSection.jsx";
import AvailabilityReminderLayer from "./AvailabilityReminderLayer.jsx";
import Landmark from "@core/scripts/components/landmark-adapter";
import Flowbox from "./Flowbox.jsx";
import ProductRecommendations from "./recommendations/ProductRecommendations.jsx";
import {Grid} from "@bonprix/design-system";
import ModelContainer from "@core/scripts/components/model-container.js";

export default function ProductPage({
                                        product,
                                        texts,
                                        productImageDimensions,
                                        breadcrumbs,
                                        staticLinks,
                                        sizeGuideTableUrl,
                                        pointOfSaleIdOverride,
                                        filterTrackingValue,
                                        rankingTrackingValue,
                                        pageViewId,
                                        pageType,
                                        loginLink,
                                        loggedIn,
                                        reviewContent,
                                        glossaryData,
                                        experiments,
                                        otherCategories,
                                        config,
                                        sessionEmail,
                                        urls,
                                        seoRecommendations,
                                        fullWidth,
                                        hideFitFinder,
                                        sizeAdvice,
                                        priceReductionCampaign
                                    }) {

    const fullWidthContentContainerRef = useRef();

    useEffect(() => {
        sendPageLandmark();
    }, []);

    const sendPageLandmark = () => {
        const {productPageLandmark} = product;
        Landmark.sendPageLandmark(JSON.parse(productPageLandmark));
    };

    const {recommendationPlaceholders, currentItem} = product;
    const {nitroOptIn, nitroEcId, nitroEnvironmentName, trackingEnvironment, personalOptIn, wishlistEnabled} = config;
    const soldOutCarouselPlaceholder = recommendationPlaceholders.find((placeholder) => placeholder.type === 'sold-out-carousel');

    const adjustElementPosition = (element) => {
        const remainingHeight = element.offsetHeight - window.innerHeight;
        if (remainingHeight > 0) {
            element.style.top = (-1 * remainingHeight) + 'px';
        }else{
            element.style.top = '';
        }
    };

    const adjustPosition = () => {
        const images = document.querySelector('.product__image-container__full_width');
        const details = document.querySelector('.product__details__full_width');

        if (images) adjustElementPosition(images);
        if (details) adjustElementPosition(details);
    };

    useEffect(() => {
        adjustPosition();
        setTimeout(adjustPosition, 1000);
        window.addEventListener('resize', adjustPosition);
        return () => {
            window.removeEventListener('resize', adjustPosition);
        };
    }, []);

    setTimeout(() => {
        adjustPosition()
    }, 1000);

    const {images} = currentItem;
    const soldOut = currentItem?.availability?.soldOut;
    const isArticleSoldOutOrHaveOneImage = images.length === 1 || soldOut;
    const isLivingAreaAssortment = ModelContainer.get('isLivingAreaAssortment');
    const imageSliderClasses = isLivingAreaAssortment || isArticleSoldOutOrHaveOneImage
        ? ' xxl:flex xxl:justify-center xxl:items-center xxl:h-full'
        : '';

    return (
        <>
            <SideSection/>
            <AvailabilityReminderLayer email={sessionEmail} texts={texts} product={product} urls={urls}/>

        {fullWidth ? (
            <Grid>
                <Grid.Item s={12}>
                    <BackToShop breadcrumbs={breadcrumbs} fullWidth={fullWidth}/>
                </Grid.Item>
                <Grid.Item s={12} l={6} xxl={8}>
                    <div className={'product__image-container__full_width' + imageSliderClasses} ref={fullWidthContentContainerRef}>
                        <ProductImageSlider
                            product={product}
                            texts={texts}
                            initialSlideIndex={product.selectedImageIndex || 0}
                            productImageDimensions={productImageDimensions}
                            fullWidth={fullWidth}
                        />
                    </div>
                </Grid.Item>
                <Grid.Item s={12} l={6} xxl={4}>
                    <div className="product__details__full_width">
                        <Details
                            product={product}
                            texts={texts}
                            staticLinks={staticLinks}
                            sizeGuideTableUrl={sizeGuideTableUrl}
                            pointOfSaleIdOverride={pointOfSaleIdOverride}
                            filterTrackingValue={filterTrackingValue}
                            rankingTrackingValue={rankingTrackingValue}
                            pageViewId={pageViewId}
                            reviewContent={reviewContent}
                            wishlistEnabled={wishlistEnabled}
                            fullWidth={fullWidth}
                            hideFitFinder={hideFitFinder}
                            sizeAdvice={sizeAdvice}
                            priceReductionCampaign={priceReductionCampaign}
                        />
                        <div className="product__accordions__full_width" onTransitionEnd={adjustPosition}>
                            <ProductAccordion
                                texts={texts}
                                experiments={experiments}
                                product={product}
                                loginLink={loginLink}
                                isLoggedIn={loggedIn}
                                glossaryData={glossaryData}
                                reviewContent={reviewContent}
                                staticLinks={staticLinks}
                                fullWidth={fullWidth}
                                contentContainerRef={fullWidthContentContainerRef}
                            />
                        </div>
                    </div>
                </Grid.Item>

                <Grid.Item s={12}>
                    <Flowbox product={product}/>
                </Grid.Item>

                <Grid.Item s={12}>
                    <div id="product-recommendations"
                         className={fullWidth ? "product-recommendations__with____full_width" : "product-recommendations"}>
                        <ProductRecommendations
                            seoRecommendations={seoRecommendations}
                            texts={texts}
                            product={product}
                            fullWidth={fullWidth}
                        />
                    </div>
                </Grid.Item>

                {otherCategories?.length > 0 && (
                    <>
                        <Grid.Item l={1}/>
                        <Grid.Item s={12} l={10}>
                            <OtherCategories otherCategories={otherCategories} texts={texts} fullWidth/>
                        </Grid.Item>
                    </>
                )}
            </Grid>
            ) : (
                <>
                    <BackToShop breadcrumbs={breadcrumbs} fullWidth={fullWidth}/>

                    <div className="product__image-container">
                        <ProductImageSlider
                            product={product}
                            texts={texts}
                            initialSlideIndex={product.selectedImageIndex || 0}
                            productImageDimensions={productImageDimensions}
                            fullWidth={fullWidth}
                        />
                    </div>
                    <div className="product__details">
                        <Details
                            product={product}
                            texts={texts}
                            staticLinks={staticLinks}
                            sizeGuideTableUrl={sizeGuideTableUrl}
                            pointOfSaleIdOverride={pointOfSaleIdOverride}
                            filterTrackingValue={filterTrackingValue}
                            rankingTrackingValue={rankingTrackingValue}
                            pageViewId={pageViewId}
                            reviewContent={reviewContent}
                            wishlistEnabled={wishlistEnabled}
                            fullWidth={fullWidth}
                            hideFitFinder={hideFitFinder}
                            sizeAdvice={sizeAdvice}
                            priceReductionCampaign={priceReductionCampaign}
                        />
                    </div>
                    <div className="product__accordions">
                        <ProductAccordion
                            texts={texts}
                            experiments={experiments}
                            product={product}
                            loginLink={loginLink}
                            isLoggedIn={loggedIn}
                            glossaryData={glossaryData}
                            reviewContent={reviewContent}
                            staticLinks={staticLinks}
                        />
                    </div>

                    <Flowbox product={product}/>

                    <div id="product-recommendations"
                         className={fullWidth ? "product-recommendations__with____full_width" : "product-recommendations"}>
                        <ProductRecommendations
                            seoRecommendations={seoRecommendations}
                            texts={texts}
                            product={product}
                            fullWidth={fullWidth}
                        />
                    </div>

                    {otherCategories?.length > 0 && (
                        <OtherCategories otherCategories={otherCategories} texts={texts}/>
                    )}
                </>
            )}

            {currentItem.availability.soldOut && (
                <SoldOutCarousel texts={texts} shopId={product.shopId} item={currentItem}/>
            )}

            {/* External components */}
            <NitroTracker
                nitroOptIn={nitroOptIn}
                nitroEcId={nitroEcId}
                nitroEnvironmentName={nitroEnvironmentName}
                trackingEnvironment={trackingEnvironment}
                pageType={pageType}
                pageViewId={pageViewId}
            />
            <PlattformAttributes config={{pageType, pageViewId}}/>
            <LastSeenStorage personalOptIn={personalOptIn} digistyleId={product.styleId.toString()}/>
        </>
    );
}
